// extracted by mini-css-extract-plugin
module.exports = {"b_change":"ListTitle_b_change__ryrX2"};